import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const permission = map.usePermission()

    if (! permission.has('write')) {
        return null
    }

    const {canMakeProduct, makeProduct} = map.commands

    const next = (chain) => {
        const {bizNodeType} = chain[0].data
        const BizNode = map.BizNode[bizNodeType]
        const isMounted = BizNode.isMounted(map, chain[0])
        const isProduct = BizNode.classes.includes('product')
        return {yieldChildren: isMounted && ! isProduct}
    }

    const iterNode = map.dfs(map.root.children, next)
    const nodes = canMakeProduct(iterNode)

    if (0 === nodes.length) {
        return null
    }

    return {
        key: 'make-all-products',
        label: '生成所有制品',
        onClick: () => makeProduct(nodes),
    }
}
